var _this = this,
  _jsxFileName = "/builds/EgNbCExi/0/ramsey-solutions/ramsey-plus/survey-ui/src/components/QuestionByType/QuestionByType.js";
/* eslint-disable no-extra-parens */
import React from "react";
import PropTypes from "prop-types";
import Question from "../Question/Question";
import Interstitial from "../Interstitial/Interstitial";
import { questionPropType } from "../../prop-types";
var QuestionByType = function QuestionByType(_ref) {
  var question = _ref.question,
    submission = _ref.submission;
  if (question.type === "INSTRUCTIONS") {
    return /*#__PURE__*/React.createElement(Interstitial, {
      instruction: question,
      submission: submission,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 11,
        columnNumber: 12
      }
    });
  }
  return /*#__PURE__*/React.createElement(Question, {
    question: question,
    submission: submission,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 14,
      columnNumber: 10
    }
  });
};
QuestionByType.propTypes = {
  question: questionPropType.isRequired,
  submission: PropTypes.element.isRequired
};
export { QuestionByType as default };